import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { NamedAdapter } from './named.adapter';
import { A365BackendModel as Model } from '../a365.backendmodel';
import { LinkTable } from '../synapselink/linktable';

const DEFAULT_STRUCTURE_OPTION_TYPE: LinkTable['structureOptionType'] = 'Clustered_ColumnStore';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LinkTable),
    adapts: {
        id: '*',
        source: {
            tableName: '*',
            schemaName: '*'
        },
        target: {
            tableName: '*',
            schemaName: '*',
            distributionOptions: {
                type: '*',
                distributionColumn: '*'
            }
        }
    }
})

export class LinkTableAdapter extends NamedAdapter<LinkTable, Model.LinkTableResource> {
    protected _toResource(linkTable: LinkTable): Model.LinkTableResource {
        return {
            id: linkTable.name,
            source: {
                tableName: linkTable.sourceTableName,
                schemaName: linkTable.sourceSchemaName
            },
            target: {
                tableName: linkTable.targetTableName,
                schemaName: linkTable.targetSchemaName,
                distributionOptions: {
                    type: linkTable.distributionType,
                    distributionColumn: linkTable.distributionColumn
                },
                structureOptions: {
                    type: linkTable.structureOptionType
                },
                partitionOptions: {
                    partitionColumns: linkTable.partitionColumns
                }
            }
        };
    }

    protected _toModel(linkTableResource: Model.LinkTableResource, linkTable?: LinkTable): LinkTable {
        if (!linkTable) {
            linkTable = LinkTable.MODEL.create();
        }
        linkTable.name = linkTableResource.id;
        if (linkTableResource.source) {
            linkTable.sourceSchemaName = linkTableResource.source.schemaName;
            linkTable.sourceTableName = linkTableResource.source.tableName;
        }
        if (linkTableResource.target) {
            linkTable.targetSchemaName = linkTableResource.target.schemaName;
            linkTable.targetTableName = linkTableResource.target.tableName;
            const distributionOptions = linkTableResource.target.distributionOptions;
            if (distributionOptions) {
                linkTable.distributionType = distributionOptions.type;
                linkTable.distributionColumn = distributionOptions.distributionColumn;
            }
            if (linkTableResource.target.partitionOptions) {
                linkTable.partitionColumns = linkTableResource.target.partitionOptions.partitionColumns || [];
            }
            linkTable.structureOptionType = linkTableResource.target.structureOptions
                && linkTableResource.target.structureOptions.type
                // Set a default value in case of empty legacy data
                || DEFAULT_STRUCTURE_OPTION_TYPE;
        }
        return linkTable;
    }
}
